<template>
  <BacklogTarefas />
</template>

<script>
import BacklogTarefas from '@/components/BacklogTarefas.vue';

export default {
  components: {
    BacklogTarefas,
  },
};
</script>
